export default __webpack_public_path__ + "static/media/no_access.bf556bf3.svg";